import { ApiClient } from "./clients";
import { Instance, ListService, Routine, Schedule } from "@/types";

export interface InstanceListService extends ListService<Instance> {
  // Userflow to this action is limited to the creation of scheduled instances
  create?: (entity: Instance) => Promise<Instance>;
}

export const InstanceService: InstanceListService = {
  async all(options?: any) {
    const params = {
      start_date: options?.start_date,
      end_date: options?.end_date,
      existing_routine_ids: "[]",
    };
    const response = await ApiClient.get<{
      routines: Routine[];
      schedules: Schedule[];
      instances: Instance[];
    }>(`/api/v1/routine/instances/user/${options?.id}/`, params);
    const result = {
      routines: response?.routines ?? [],
      schedules: response?.schedules ?? [],
      instances: (response?.instances ?? []).map((i: any) => ({
        ...i,
        sending: false,
      })),
    };
    return result as any;
  },
  async add(entity: Instance, request) {
    const instance = await ApiClient.post<
      Instance & {
        template: number | string;
      }
    >(
      `/api/v1/routine/template/${entity.template_id}/instance/`,
      entity,
      false,
      request
    );
    const { template, ...instanceData } = instance ?? {};
    return {
      ...entity,
      ...instanceData,
      sending: false,
      template_id: +(template ?? 0),
    };
  },
  async load(id: number) {
    const result = await ApiClient.get<{
      instance: Instance & { template: number | string };
    }>(`/api/v1/instance/${id}/`, {
      fetch_execution: "1",
    });
    if (!result || !result.instance) return Promise.reject(null);
    const { template, ...instanceData } = result.instance;
    return {
      ...instanceData,
      template_id: +(template ?? 0),
      sending: false,
    };
  },
  async create(entity: Instance) {
    // Useful only for the creation of scheduled instances
    const instance = await ApiClient.post<Instance>(
      `/api/v1/routine/template/${entity.template_id}/instance/`,
      {
        all_day: entity.all_day,
        end_date: entity.end_date,
        has_started: true,
        instructions: entity.instructions,
        is_done: false,
        is_dst: entity.is_dst,
        schedule: entity.schedule,
        start_date: entity.start_date,
        properties: entity.scheduler?.properties,
        team_id: entity.team_id,
        timezone: entity.timezone,
        timezone_offset: entity.timezone_offset,
        users: entity.users,
      }
    );
    if (!instance) {
      throw new Error("Error creating instance");
    }
    return { ...instance, uuid: entity.uuid };
  },
};
